import { MutableRefObject, useRef, useState } from "react";
import searchSvg from "../../../../../shared-assets/animations/search.svg";
import searchGif from "../../../../../shared-assets/animations/search.gif";
import { _c } from "../../../../services/text-services";
import styles from "./serach-form.component.module.scss";
import GifIcon from "../../gif-icon/gif-icon";
interface SearchFormProps {
  setQuery: (query: string) => void;
  onEnterKeyPressed: () => void;
  onEscapeKeyPressed: () => void;
  onFocus: () => void;
  isMenu?: boolean;
  isMobile?: boolean;
}
function SearchForm({
  onEnterKeyPressed,
  onEscapeKeyPressed,
  onFocus,
  setQuery,
  isMenu,
  isMobile
}: SearchFormProps) {
  const queryEl = useRef<HTMLInputElement>();
  const [input, setInput] = useState("");
  return (
    <form autoComplete="off">
      <div
        className={_c(
          styles,
          "search-inputs " +
            (isMobile ? "is-mobile" : isMenu ? "is-menu" : "is-home")
        )}
      >
        <input
          ref={queryEl as MutableRefObject<HTMLInputElement>}
          maxLength={50}
          className={_c(styles, "search-input py-3 px-4")}
          required
          autoComplete="off"
          name="keyword"
          type="text"
          placeholder="  نام انیمیشن مورد نظر خود را جستجو کنید"
          value={input}
          onFocus={() => onFocus()}
          onChange={e => {
            setQuery(e.target.value);
            setInput(e.target.value);
          }}
          onKeyDown={e => {
            switch (e.key) {
              case "Escape":
                onEscapeKeyPressed();
                setInput("");
                queryEl?.current?.blur();
                break;
              case "Enter":
                e.preventDefault();
                onEnterKeyPressed();
                break;
              default:
                break;
            }
          }}
        />
        <button type="submit">
          <div id="search-icon">
            <GifIcon
              animationGif={searchGif}
              animationStop={searchSvg}
              durationMilliSecond={2760}
              height={30}
              width={40}
              alt="search"
            />
          </div>
        </button>
      </div>
    </form>
  );
}

export default SearchForm;
